// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"317":"component---src-components-default-page-tsx","532":"styles"}[chunkId] || chunkId) + "-" + {"175":"06c47e4c25f9f6b5daf1","231":"e45e36aef1f768395156","317":"06569a4cfb538b4665dc","503":"b6d886fe9f133817971f","532":"776643c02df1380d7ebc"}[chunkId] + ".js";
};